export default "__VITE_ASSET__D0Zf_6ls__"